import React, { PureComponent } from 'react';

import { setCookie, getCookie } from '../../../lib/cookies';


export default class QuestionnaireOverlay extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showOverlay: false };
  }

  componentDidMount() {
    if (getCookie('questionaryOverlay') === '') {
      this.setState({ showOverlay: true });
      document.getElementsByTagName('body')[0].classList.add('modal-open');
    }
  }

  closeOverlay = () => {
    this.setState({ showOverlay: false });
    setCookie('questionaryOverlay', 'shown', 30);
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
  }

  render() {
    return (
      <div>
        {this.state.showOverlay && (
          <div className="block-questionary-overlay">
            <div className="block-questionary-overlay__content">

              <h3>
                <i className="icon-info-alt-2" />
                <span>Tip</span>
                <i className="icon-arrow-right" />
              </h3>
              <p>Ke každé otázce si můžete přečíst dovysvětlující informace.</p>
              <a
                onClick={this.closeOverlay}
                className="block-questionary-overlay__label"
                htmlFor="block-questionary-overlay"
              >
                Rozumím
              </a>
            </div>
          </div>
        )
        }
      </div>
    );
  }
}
